<template>
<table :class="$style['customer-message-old-to-new']">
    <pt-message-table-item label="手机号" :tdMaxWidth="tdMaxWidth">{{customerMessage.userMobile}}</pt-message-table-item>
    <pt-message-table-item label="常住地区" v-if="userType==='new'">
          <template v-if="customerMessage.region">
            {{customerMessage.region.provinceName+customerMessage.region.cityName+customerMessage.region.districtName}}
          </template>
          <template v-else>--</template>
        </pt-message-table-item>
    <pt-message-table-item label="合同信息">
      <table :class="$style['customer-CPS-message']" v-if="customerMessage.contractInformation&&customerMessage.contractInformation.length">
        <tr>
          <th>CPS合同号</th>
          <th>合同姓名</th>
          <th>合同地区</th>
           <th>产品名称</th>
           <th>产品条码</th>
           <template v-if="userType==='new'">
           <th>生产医院</th>
           <th>医院编码</th>
           </template>
          <th>业务员姓名</th>
          <th>业务员工号</th>
        </tr>
        <!-- <template v-for="item in customerMessage.contractInformation"> -->
        <tr v-for="(item,i) in customerMessage.contractInformation" :key="i">
          <td>{{item.contractCode?item.contractCode:'--'}}</td>
          <td>{{item.motherName?item.motherName:'--'}}</td>
          <td>{{item.cpsRegion?item.cpsRegion:"--"}}</td>
          <td>
            <div v-for="(etem,index) in item.productInformation" :key="index">
              {{etem.name?etem.name:"--"}}
                <!-- {{etem.name?(etem.name+(etem.productCode?("-"+etem.productCode):'')):'--'}} -->
            </div>
           </td>
           <td>
              <div v-for="(etem,index) in item.productInformation" :key="index">
                {{etem.barcode?etem.barcode:"--"}}
            </div>
           </td>
           <template v-if="userType==='new'">
           <td>{{item.birthHospital?item.birthHospital:"--"}}</td>
           <td>{{item.birthHospitalCode?item.birthHospitalCode:"--"}}</td>
           </template>
          <td>{{item.salesName?item.salesName:"--"}}</td>
          <td>{{item.salesWorkNumber?item.salesWorkNumber:"--"}}</td>
        </tr>
        <!-- </template> -->
      </table>
      <template v-else>--</template>
      </pt-message-table-item>
      <!-- <template v-if="userType==='new'&&customerMessage.contractInformation&&customerMessage.contractInformation[0]">
        <pt-message-table-item  :tdMaxWidth="tdMaxWidth" label="合同号">{{customerMessage.contractInformation[0].contractCode?customerMessage.contractInformation[0].contractCode:'--'}}</pt-message-table-item>
        <pt-message-table-item label="合同姓名">{{customerMessage.contractInformation[0].motherName?customerMessage.contractInformation[0].motherName:"--"}}</pt-message-table-item>
        <pt-message-table-item label="合同地区">{{customerMessage.contractInformation[0].cpsRegion?customerMessage.contractInformation[0].cpsRegion:"--"}}</pt-message-table-item>
        <pt-message-table-item label="产品名称">
          <template v-if="customerMessage.contractInformation[0].productInformation">
            <div v-for="(item,i) in customerMessage.contractInformation[0].productInformation" :key="i">
              {{item.name?(item.name+(item.productCode?("-"+item.productCode):'')):'--'}}
            </div>
          </template>
        </pt-message-table-item>
        <pt-message-table-item label="生产医院">{{customerMessage.contractInformation[0].birthHospital?customerMessage.contractInformation[0].birthHospital:"--"}}</pt-message-table-item>
        <pt-message-table-item label="医院编码">{{customerMessage.contractInformation[0].birthHospitalCode?customerMessage.contractInformation[0].birthHospitalCode:"--"}}</pt-message-table-item>
        <pt-message-table-item label="业余员姓名">{{customerMessage.contractInformation[0].salesName?customerMessage.contractInformation[0].salesName:"--"}}</pt-message-table-item>
        <pt-message-table-item label="业余员工号">{{customerMessage.contractInformation[0].salesWorkNumber?customerMessage.contractInformation[0].salesWorkNumber:"--"}}</pt-message-table-item>
      </template> -->
        <!-- <pt-message-table-item label="催费次数"  v-if="userType==='old'">
          {{BringNewAuditDetail.extendInformation&&(BringNewAuditDetail.extendInformation.remindPayNumber?BringNewAuditDetail.extendInformation.remindPayNumber:'--')}}
          </pt-message-table-item> -->
    <pt-message-table-item label="销售订单号"  v-if="userType==='new'">
      <template>
        <router-link v-if="BringNewAuditDetail.mallOrderNumber" :class="$style['get-customer-detail']" :to ="`/mall-order-all/order-detail/${BringNewAuditDetail.mallOrderId}/detail`">
          {{BringNewAuditDetail.mallOrderNumber}}
        </router-link>
      </template>
    </pt-message-table-item>
    <pt-message-table-item label="是否有报告"  v-if="userType==='new'">{{extendInformation.hasReport?'有':"无"}}</pt-message-table-item>
</table>
</template>
<script>
export default {
  props: {
    BringNewAuditDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    tdMaxWidth: {
      type: [String, Number],
      default: null
    },
    customerMessage: {
      type: Object,
      default: function () {
        return {}
      }
    },
    userType: {
      type: String,
      default: null
    }
  },
  computed: {
    //
    extendInformation () {
      return this.BringNewAuditDetail.extendInformation || {}
    },
    customerBringNew () {
      return this.extendInformation.customerBringNew || {}
    }
  }
}
</script>
<style lang="less" module>

.customer-message-old-to-new{
  padding: 0 20px;
  // width: 100%;
  :global
  .pt-message-table-item{
    :first-child{
      // width: 114PX
    }
  }
}
.get-customer-detail{
  color: #edbe81;
}
.customer-CPS-message{
  // border:1px solid #F00;
  th{
    padding: 10px;
     border-bottom: 1px solid #ebeef5
  }
  td{
    padding: 10px;
    border-bottom: 1px solid #ebeef5
  }

}
</style>
